import { render, staticRenderFns } from "./AccountTypeAdd.vue?vue&type=template&id=389be595&"
import script from "./AccountTypeAdd.vue?vue&type=script&lang=ts&"
export * from "./AccountTypeAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389be595')) {
      api.createRecord('389be595', component.options)
    } else {
      api.reload('389be595', component.options)
    }
    module.hot.accept("./AccountTypeAdd.vue?vue&type=template&id=389be595&", function () {
      api.rerender('389be595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/accountType/AccountTypeAdd.vue"
export default component.exports